import React from "react";
import { useNavigate } from "react-router-dom";
import { FaChartBar, FaWpforms } from "react-icons/fa";

function Tile({ title, description, action, onClick, icon: Icon }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative w-full text-left bg-white rounded-2xl shadow-sm border border-gray-100 hover:border-emerald-400 hover:shadow-md transition-all p-5 sm:p-6 flex flex-col gap-2 focus:outline-none focus:ring-2 focus:ring-emerald-500 overflow-hidden"
    >
      {Icon && (
        <div className="absolute right-4 top-1/2 -translate-y-1/2 opacity-25 pointer-events-none">
          <Icon className="text-emerald-600" size={92} aria-hidden />
        </div>
      )}

      <div className="text-sm font-semibold text-emerald-700 uppercase tracking-wide">
        {title}
      </div>
      <div className="text-sm text-gray-600 max-w-[18rem]">{description}</div>
      <div className="mt-2 text-xs font-medium text-emerald-700">{action}</div>
    </button>
  );
}

export default function HomeGraduadoPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen max-w-7xl mx-auto pt-16 md:pt-20 pb-28 md:pb-24 px-4 sm:px-5 md:px-6">
      <div className="mb-6 flex flex-col sm:flex-row sm:flex-wrap sm:items-end sm:justify-between gap-4">
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">
            Página inicial
          </h1>
          <p className="text-sm sm:text-base text-gray-600 mt-1">
            Escolha o módulo que pretende utilizar.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        <Tile
          title="Estatísticas"
          description="Ver números e informações dos graduados."
          action="Ir para Estatísticas"
          icon={FaChartBar}
          onClick={() => navigate("/estatisticas")}
        />
        <Tile
          title="Formulários"
          description="Criar e gerir formulários para recolher dados."
          action="Ir para Formulários"
          icon={FaWpforms}
          onClick={() => navigate("/formularios")}
        />
      </div>
    </div>
  );
}

